import React, { useState } from "react";
import {
  PageContainer,
  TabsContainer,
  ContentContainer,
} from "./Snapshot.styled";
import { Tabs } from "@ann/web-components";
import Insight from "./components/Insight";
import Tags from "./components/Tags";
import Actions from "./components/Actions";
import { useNoteSnapshot } from "./hooks";

const Snapshot = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const {
    summary,
    opportunities,
    recommendations,
    riskFactors,
    tags,
    traits,
    nba,
    loading,
    error,
    hasInsightData,
    hasTagsData,
    hasActionsData,
    handleRefresh,
  } = useNoteSnapshot();

  return (
    <PageContainer>
      <Tabs defaultIndex={selectedTab} size="medium" onChange={setSelectedTab}>
        <TabsContainer>
          <Tabs.List>
            <Tabs.Tab iconLeft="searchInsights" index={0}>
              Insight
            </Tabs.Tab>
            <Tabs.Tab iconLeft="sell" index={1}>
              Tags
            </Tabs.Tab>
            <Tabs.Tab iconLeft="mindfulness" index={2}>
              Actions
            </Tabs.Tab>
          </Tabs.List>
        </TabsContainer>

        <ContentContainer>
          <Tabs.Panel index={0}>
            <Insight
              hasData={hasInsightData}
              loading={loading}
              error={error}
              onRefresh={handleRefresh}
              summary={summary}
              opportunities={opportunities}
              recommendations={recommendations}
              riskFactors={riskFactors}
            />
          </Tabs.Panel>
          <Tabs.Panel index={1}>
            <Tags
              hasData={hasTagsData}
              loading={loading}
              error={error}
              onRefresh={handleRefresh}
              tags={tags}
            />
          </Tabs.Panel>
          <Tabs.Panel index={2}>
            <Actions
              hasData={hasActionsData}
              loading={loading}
              error={error}
              onRefresh={handleRefresh}
              traits={traits}
              nba={nba}
            />
          </Tabs.Panel>
        </ContentContainer>
      </Tabs>
    </PageContainer>
  );
};

export default Snapshot;
